export enum RegistreType {
	Siren = 'siren',
	Tahiti = 'tahiti',
	RidSiren = 'ridSiren',
	RegistreEquivalent = 'registreEquivalent'
}
